export default __webpack_public_path__ + "09b9db330821feb1c68a662e981bad51.jpg";